<!-- eslint-disable -->
<template lang="pug">
    .example
        .example__container(
            :class="numberSizeClass"
            :style="exampleStyle"
        )
            span.example__part(:class="{'example__part_left': !playersNumber}")
                | {{ leftNumber }}
            | &nbsp;
            span.example__operation {{ example.operation === '*' ? '&times;' : '&divide;' }}
            | &nbsp;
            span.example__part(:class="{'example__part_right': !playersNumber}")
                | {{ rightNumber }}
        template(v-if="!dictation")
            .example__answer
                template(v-if="!playersNumber")
                    span.example__answer-header(v-if="!checkedWidthOfDevice")
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_enterTheAnswer') }}
                    span.example__answer-header(v-else)
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_answerForMulAndDiv') }}
                cs-input.example__input(
                    @input.prevent.native = "answer = handleDigitInput($event)"
                    @keyup.native.enter="checkAnswer(playersNumber > 1)"
                    ref="input"
                    :disabled="!startGame"
                    :correct="correct"
                    :wrong="!correct && !startGame"
                )
                template(v-if="remainder")
                    span.example__answer-header
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_enterTheRemainder') }}
                cs-input.example__input(
                    v-if="remainder"
                    @input.prevent.native = "enteredRemainder = handleDigitInput($event)"
                    @keyup.native.enter="checkAnswer(playersNumber > 1)"
                    ref="inputRemainder"
                    :disabled="!startGame"
                    :correct="correct"
                    :wrong="!correct && !startGame"
                )
            cs-button(
                @click="checkAnswer(playersNumber > 1)",
                color="blue"
                :disabled="!startGame"
            )
                | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
</template>

<script>
    import handleDigitInput from '../../../../utils/trainer/handleDigitInput';

    export default {
        props: {
            example: Object,
            checkMultiplayerAnswers: Boolean,
            dictation: Boolean,
            numbers: Boolean,
            playersNumber: Number,
            colorForStudent: String,
            startGame: {
                type: Boolean,
                default: false,
            },
            correct: {
                type: Boolean,
                default: false,
            },
            isBattle: {
                type: Boolean,
                default: false,
            },
            remainder: Boolean,
        },
        data() {
            return {
                answer: '',
                enteredRemainder: '',
                isFocused: false,
                focusTimeout: null,
            };
        },
        mounted() {
            this.focusTimeout = setTimeout(() => {
                this.$refs.input?.$el.focus();
            }, 200);
        },
        watch: {
            checkMultiplayerAnswers(val) {
                if (val) {
                    this.checkAnswer(true);
                }
            },
        },
        computed: {
            leftNumber() {
                return this.example.left;
            },
            rightNumber() {
                return this.example.right;
            },
            checkedWidthOfDevice() {
                let width = window.innerWidth;
                return width < 768;
            },
            exampleStyle() {
                return {
                    color: this.playersNumber !== 0 && this.colorForStudent,
                };
            },
            numberSizeClass() {
                const length = this.leftNumber.toString().length + this.rightNumber.toString().length;
                if (length > 16) {
                    return 'example__container_size-medium';
                }
                if (length > 10) {
                    return 'example__container_size-large';
                }
                if (length > 6) {
                    return 'example__container_size-big';
                }
                return '';
            },
        },
        methods: {
            checkAnswer(isMultiplayer = false) {
                if (this.remainder && (!this.answer || !this.enteredRemainder)) {
                    return;
                }
                if (this.answer || this.answer === 0 || isMultiplayer) {
                    document.activeElement.blur();
                    this.isFocused = false;
                    if (this.enteredRemainder) {
                        let quotientAndRemainder = {
                            quotient: +this.answer,
                            givenRemainder: +this.enteredRemainder,
                        };
                        this.$emit('answer', quotientAndRemainder);
                    } else {
                        this.$emit('answer', this.answer);
                    }
                }
            },
            handleDigitInput,
        },
        beforeDestroy() {
            clearTimeout(this.focusTimeout);
        },
    };
</script>

<style scoped lang="scss">
    .example {
        text-align: center;
    }

    .example__container {
        display: flex;
        justify-content: center;
        font-size: $font-size-44;
        font-weight: 500;
        flex-wrap: wrap;
        @include media($sm) {
            font-size: $font-size-120;
        }
        @include media($md) {
            font-size: $font-size-150;
        }
        @include media($lg) {
            font-size: $font-size-200;
        }
    }

    .example__container_size-big {
        font-size: $font-size-32;
        @include media($sm) {
            font-size: $font-size-76;
        }
        @include media($md) {
            font-size: $font-size-100;
        }
        @include media($lg) {
            font-size: $font-size-120;
        }
    }

    .example__container_size-large {
        font-size: $font-size-20;
        @include media($sm) {
            font-size: $font-size-44;
        }
        @include media($md) {
            font-size: $font-size-76;
        }
        @include media($lg) {
            font-size: $font-size-100;
        }
    }

    .example__container_size-medium {
        font-size: $font-size-22;
        @include media($sm) {
            font-size: $font-size-26;
        }
        @include media($md) {
            font-size: $font-size-44;
        }
        @include media($lg) {
            font-size: $font-size-56;
        }
    }

    .example__answer {
        display: flex;
        flex-direction: column;
        align-items: center;
        @include stack-space($space-base);
    }

    .example__answer-header {
        @include stack-space($space-base);
        font-size: 22px;
        font-weight: 500;
        white-space: nowrap;
        @include media($md) {
            font-size: 32px;
        }
    }

    .example__input {
        max-width: 170px;
        margin-right: 10px;
        height: 80px;
        font-size: 22px !important;
        text-align: center;
        @include media($md) {
            max-width: 280px;
            font-size: 32px !important;
        }
    }

    .example__part_left {
        color: $hsl-color-blue-56;
    }

    .example__part_right {
        color: $hsl-color-green-58;
    }

    .example__operation {
        color: $hsl-color-orange-56;
    }

    $players-amount-sizes: (
        '12': (1),
        '6': (2),
        '4': (3),
        '3': (4),
    );

    .multiplayer {
        .example {
            .cs-button {
                font-weight: 500;
            }
        }
    }

    @each $col-size, $size in $players-amount-sizes {
        .multiplayer__item--is-#{$col-size} .example__container {
            @if $size == 2 {
                @include media($xlg) {
                    font-size: 38px;
                }
                @include media($xl) {
                    font-size: 46px;
                }
                @include media($xxl) {
                    font-size: 70px;
                }
            }
            @if $size == 3 {
                @include media($xlg) {
                    font-size: 24px;
                }
                @include media($xl) {
                    font-size: 32px;
                }
                @include media($xxl) {
                    font-size: 46px;
                }
            }
            @if $size == 4 {
                @include media($xl) {
                    font-size: 24px;
                }
                @include media($xxl) {
                    font-size: 36px;
                }
            }
        }

        .multiplayer--multiline .multiplayer__item--is-#{$col-size} .example__container {
            @if $size == 2 {
                @include media($xlg) {
                    font-size: 28px;
                }
                @include media($xl) {
                    font-size: 46px;
                }
            }
            @if $size == 3 {
                @include media($xlg) {
                    font-size: 24px;
                }
                @include media($xl) {
                    font-size: 32px;
                }
                @include media($xxl) {
                    font-size: 46px;
                }
            }
            @if $size == 4 {
                @include media($xlg) {
                    font-size: 18px;
                }
                @include media($xl) {
                    font-size: 24px;
                }
                @include media($xxl) {
                    font-size: 36px;
                }
            }
        }

        .multiplayer__item--is-#{$col-size} .example__input {
            @if $size == 2 {
                @include media($xlg) {
                    max-width: 250px;
                    max-height: 70px;
                }
                @include media($xl) {
                    max-height: 80px;
                }
            } @else if $size == 3 {
                @include media($xlg) {
                    max-width: 180px;
                    max-height: 42px;
                }
                @include media($xl) {
                    max-width: 250px;
                    max-height: 60px;
                }
                @include media($xxl) {
                    max-width: 250px;
                    max-height: 80px;
                }
            } @else if $size == 4 {
                @include media($xlg) {
                    max-width: 150px;
                    max-height: 40px;
                }
                @include media($xl) {
                    max-width: 250px;
                    max-height: 50px;
                }
                @include media($xxl) {
                    max-width: 250px;
                    max-height: 80px;
                }
            }
        }

        .multiplayer--multiline .multiplayer__item--is-#{$col-size} .example__input {
            @if $size == 2 {
                @include media($xlg) {
                    max-width: 150px;
                    max-height: 40px;
                }
                @include media($xl) {
                    max-width: 250px;
                    max-height: 50px;
                }
            } @else if $size == 3 {
                @include media($xlg) {
                    max-width: 150px;
                    max-height: 40px;
                }
                @include media($xl) {
                    max-width: 250px;
                    max-height: 50px;
                }
                @include media($xxl) {
                    max-width: 250px;
                    max-height: 60px;
                }
            } @else if $size == 4 {
                @include media($xlg) {
                    max-width: 110px;
                    max-height: 32px;
                }
                @include media($xl) {
                    max-width: 180px;
                    max-height: 42px;
                }
                @include media($xxl) {
                    max-width: 250px;
                    max-height: 60px;
                }
            }
        }
    }
</style>
